/**
 * Hard-coded demo jobs for the `/1` and `/2` routes — copied verbatim from Flutter
 * presentation/web_job_description/web_job_description_1.dart and _2.dart (`jobDetails`).
 * Flutter never fetches anything for these pages, and neither does React.
 */

export interface DemoJobDetails {
  posted: string;
  applicants: number;
  views: number;
  managementLevel: number;
  experience: string;
  location: string;
  role: string;
  responsibilities: string[];
  skills: string[];
  education: string;
  salary: string;
  industry: string;
  department: string;
  employmentType: string;
  keywords: string[];
}

const KEYWORDS = [
  'java developer',
  'flutter developer',
  'java',
  'flutter',
  'iexchange dev',
  'iexchange',
  'flutter job',
  'java job',
];

/** WebJobDescriptionPage1 */
export const JOB_DESCRIPTION_1: DemoJobDetails = {
  posted: '2 days ago',
  applicants: 120,
  views: 1000,
  managementLevel: 8,
  experience: 'Min 5 years',
  location: 'Mumbai, Maharashtra, India',
  role: 'Java Developer',
  responsibilities: [
    'Design and develop high-volume, low-latency applications for mission-critical systems',
    'Contribute to all phases of the development lifecycle',
    'Write well designed, efficient, and testable code',
    'Ensure designs are in compliance with specifications',
    'Prepare and produce releases of software components',
    'Support continuous improvement by investigating alternatives and technologies',
  ],
  skills: ['Java', 'Spring Boot', 'Hibernate', 'RESTful APIs'],
  education: "Bachelor's degree in Computer Science or related field",
  salary: 'Competitive',
  industry: 'Information Technology',
  department: 'Software Development',
  employmentType: 'Full Time',
  keywords: KEYWORDS,
};

/** WebJobDescriptionPage2 */
export const JOB_DESCRIPTION_2: DemoJobDetails = {
  posted: '1 day ago',
  applicants: 80,
  views: 900,
  managementLevel: 7,
  experience: 'Min 4 years',
  location: 'Banglore, karnataka, India',
  role: 'Flutter Developer',
  responsibilities: [
    'Develop cross-platform mobile applications using Flutter framework',
    'Collaborate with the design team to implement user interfaces',
    'Write clean, maintainable, and efficient code',
    'Troubleshoot, debug, and optimize application performance',
    'Stay updated with the latest Flutter and Dart developments',
  ],
  skills: ['Flutter', 'Dart', 'State Management', 'API Integration'],
  education: "Bachelor's degree in Computer Science or related field",
  salary: 'Competitive',
  industry: 'Information Technology',
  department: 'Mobile App Development',
  employmentType: 'Full Time',
  keywords: KEYWORDS,
};
